// src/pages/Settings.js
import React from 'react';
import './Settings.css';

const Settings = () => {
  return (
    <div className="settings-container">
      <div className="page-header">
        <h1>Settings</h1>
        <p>Manage your account preferences</p>
      </div>
      <div className="coming-soon">
        <h2>⚙️ Coming Soon</h2>
        <p>Settings page is under development</p>
      </div>
    </div>
  );
};

export default Settings;